<template>
  <v-card>
    <v-card-title primary-title class="justify-center">
      <div>
        <div class="display-1 font-weight-medium blue--text">
          <v-icon large>face</v-icon>
          Patient
        </div>
        <center>
          <span class="subheading green--text">Create</span>
        </center>
      </div>
    </v-card-title>
    <v-card-text>
      <v-flex xs10 offset-xs1>
        <v-form ref="form" v-model="validForm" lazy-validation>
          <v-container fluid grid-list-md>
            <v-layout row wrap v-if="this.patientForm">
              <v-flex xs12>
                <v-text-field
                  label="ID"
                  background-color="blue lighten-2"
                  v-model.trim="patientID"
                  outline
                  clearable
                  :rules="rules.patientID"
                  maxlength="64"
                >
                  <v-tooltip
                    slot="prepend"
                    bottom
                  >
                    <v-icon slot="activator">help_outline</v-icon>
                    You can choose a unique ID. If you leave it blank, the system will auto-generate it.
                  </v-tooltip>
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Full Name"
                  v-model.trim="fullName"
                  background-color="blue lighten-3"
                  required
                  outline
                  :rules="rules.fullName"
                  maxlength="100"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-layout>
                  <v-flex xs6>
                    <v-menu
                    ref="dateOfBirth_menu"
                    :close-on-content-click="false"
                    v-model="dateOfBirth_menu"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    >
                      <v-text-field
                      slot="activator"
                      v-model="dateOfBirth"
                      label="Date of Birth"
                      prepend-icon="event"
                      background-color="blue lighten-3"
                      readonly
                      outline
                      ></v-text-field>
                      <v-date-picker
                      ref="picker"
                      v-model="dateOfBirth"
                      :max="new Date().toISOString().substr(0, 10)"
                      min="1900-01-01"
                      @change="dateOfBirth_save"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      v-model="gender"
                      :items="gender_items"
                      label="Gender"
                      outline
                      background-color="blue lighten-3"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="MyOffspring ID"
                  v-model.trim="myOffspringID"
                  background-color="blue lighten-3"
                  outline
                  :rules="rules.myOffspringID"
                  maxlength="64"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="E-mail"
                  background-color="blue lighten-3"
                  v-model.trim="email"
                  outline
                  :rules="rules.email"
                  maxlength="250"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Address"
                  background-color="blue lighten-3"
                  v-model.trim="address"
                  outline
                  maxlength="250"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Phone Number (numbers only)"
                  background-color="blue lighten-3"
                  v-model.trim="phoneNumber"
                  outline
                  :rules="rules.phone"
                  maxlength="20"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 align-center text-xs-center>
                <v-btn @click="send" color="info" :disabled="!validForm || fullName == '' || dateOfBirth == ''">
                  Save
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center text-xs-center v-if="this.awaitingTx">
              <v-flex xs12>
                <span class="title blue--text">
                  Transaction broadcasted to the <b>Althash Blockchain</b>!
                </span>
              </v-flex>
              <v-flex xs12>
                Awaiting confirmation from the network...
              </v-flex>
              <v-flex xs12>
                <v-progress-linear :indeterminate="true"></v-progress-linear>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center text-xs-center v-if="this.txError">
              <v-flex xs12>
                <span class="red--text">
                  {{ this.txErrorDesc }}
                </span>
              </v-flex>
              <v-flex xs12>
                <v-btn flat class="green--text" @click="txError = false; patientForm = true">
                  Back to patient creation
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center text-xs-center v-if="this.txConfirmed">
              <v-flex xs12>
                <span class="title blue--text">
                  Transaction confirmed!
                </span>
              </v-flex>
              <v-flex xs12>
                The patient is registered.
              </v-flex>
              <v-flex xs12>
                <v-btn color="info" @click="patientDialog = true">
                  Open patient info
                </v-btn>
              </v-flex>
              <v-flex xs12>
                <v-btn flat class="green--text" @click="txConfirmed = false; patientForm = true">
                  Create another patient
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-flex>   
    </v-card-text>
    <v-dialog v-model="confirmSendDialog" persistent max-width="50%">
      <v-card>
        <v-card-title>
          <span class="headline">
          {{ $t('send_to_contract.confirm') }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <b>Please store the ID below in a safe place, as it is the unique ID for this registration.</b>
              </v-flex>
              <v-flex xs10>
                <v-text-field label="Patient ID" v-model="patientID" disabled></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-btn small class="mt-3" color="cyan" v-clipboard:copy="patientID" v-clipboard:success="onCopySucc" v-clipboard:error="onCopyError">
                  {{ $t('common.copy') }}
                </v-btn>
              </v-flex>
              <v-flex xs12>
                <v-textarea label="Raw Tx" v-model="rawTx" disabled></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="confirmSend" v-show="canSend && !sending">{{ $t('common.confirm') }}</v-btn>
          <v-btn class="red--text darken-1" flat @click.native="confirmSendDialog = false" :v-show="!sending">{{ $t('common.cancel') }}</v-btn>
          <v-progress-circular indeterminate :size="50" v-show="sending" class="primary--text"></v-progress-circular>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="patientDialog" width="600px">
      <span id="patient">
        <v-card class="modal-detail">
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout row wrap align-center text-xs-center>
                <v-flex xs6>
                  <img src="~assets/images/logo_althash_health_top.png" style="width: auto; height: 40px; float: left;">
                </v-flex>
                <v-flex xs6>
                  <img src="~assets/images/logo_althash.png" style="width: auto; height: 40px; float: right;">
                </v-flex>
                <v-flex xs12>
                  <span class="font-weight-bold my-2 headline" id="title">
                    Patient Info
                  </span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <p>
                    <b>{{ this.todayDate }}</b>
                  </p>
                  <p>
                    Name: <b>{{ this.fullName }}</b>
                  </p>
                  <p>
                    Althash Health ID: <b>{{ this.patientID }}</b>
                  </p>
                  <p class="text-xs-center">
                    <img :src="qr" style="width: 100px; height: auto;"/>
                    <br>
                    <v-btn icon @click="print">
                      <v-icon>print</v-icon>
                    </v-btn>
                  </p>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </span>
    </v-dialog>
  </v-card>
</template>

<style scoped>
  .error {
    font-weight: bold;
    color: red;
  }

  .cursor:hover {
    cursor: pointer;
  }

  .modal-detail {
    background-image: url("~assets/images/myoffspring_border.png");
  }
</style>

<script>
  import webWallet from 'libs/web-wallet'
  import abi from 'ethjs-abi'
  import server from 'libs/server'
  import sha256 from 'js-sha256'
  import qrcode from 'qrcode'
  import base58 from 'bs58'
  import config from 'libs/config'
  import axios from 'axios'
  import printd from 'printd'

  const contractAddress = config.getNetwork() == "mainnet" ? "07ba64f3210d351da06958405231b10ccb2fdc56" : "0";

  const abiJson = JSON.parse(
    '[{"constant": false, "inputs": [{"name": "_patientID", "type": "string"}, {"name": "_patientFullName", "type": "string"}, {"name": "_patientDateOfBirth", "type": "uint256"}, {"name": "_myOffspringID", "type": "string"}, {"name": "_patientGender", "type": "uint8"}, {"name": "_patientEmail", "type": "string"}, {"name": "_patientAddress", "type": "string"}, {"name": "_patientPhone", "type": "uint256"} ], "name": "setPatientDetails", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [], "name": "potentialOwner", "outputs": [{"name": "", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [], "name": "owner", "outputs": [{"name": "", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_patientID", "type": "string"} ], "name": "isPatientValid", "outputs": [{"name": "", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_newAddress", "type": "address"} ], "name": "setAHUserContractAddress", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": false, "inputs": [{"name": "_patientID", "type": "string"} ], "name": "invalidatePatient", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [], "name": "myOffspringContractAddress", "outputs": [{"name": "", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [], "name": "AHUserContractAddress", "outputs": [{"name": "", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "newOwner", "type": "address"} ], "name": "ownershipTransfer", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_patientID", "type": "string"} ], "name": "getPatientDetails", "outputs": [{"name": "patientFullName", "type": "string"}, {"name": "patientDateOfBirth", "type": "uint256"}, {"name": "myOffspringID", "type": "string"}, {"name": "patientGender", "type": "uint256"}, {"name": "patientEmail", "type": "string"}, {"name": "patientAddress", "type": "string"}, {"name": "patientPhone", "type": "uint256"}, {"name": "updatedBy", "type": "address"}, {"name": "valid", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [], "name": "ownershipTransferConfirm", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor"} ]'
  );

  export default {
    data () {
      return {
        wallet: webWallet.getWallet(),
        validForm: false,
        localUserAccessLevel: this.localUserAccessLevel,
        userFound: false,
        gasPrice: '40',
        gasLimit: '2500000',
        fee: '0.01',
        confirmSendDialog: false,
        execResultDialog: false,
        rawTx: 'loading...',
        canSend: false,
        sending: false,
        patientID: '',
        fullName: '',
        myOffspringID: '',
        email: '',
        address: '',
        phoneNumber: '',
        gender: '',
        gender_items: ['Male','Female','Other'],
        dateOfBirth_menu: false,
        dateOfBirth: '',
        patientForm: true,
        awaitingTx: false,
        txConfirmed: false,
        txErrorDesc: '',
        patientDialog: false,
        qr: '',
        rules: {
          patientID: [val => (val == '' || /^[a-zA-Z0-9]+$/.test(val)) || 'Patient ID is invalid.'],
          fullName: [val => (val == '' || /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/.test(val)) || 'Name is invalid.'],
          myOffspringID: [val => (val == '' || /^[a-zA-Z0-9]+$/.test(val)) || 'MyOffspring ID is invalid.'],
          email: [val => (val == '' || /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,4}$/.test(val)) || 'E-mail is invalid.'],
          phone: [val => (val == '' || /^[0-9]*$/.test(val)) || 'Phone number is invalid.']
        }
      }
    },
    props: ['localUserAccessLevel'],
    methods: {
      print(){
        const cssText = `
                          #title {
                            font-family: Arial, Helvetica, sans-serif;
                            font-weight: bold;
                            font-size: x-large;
                            text-align: center;                      
                            display: block;
                            padding: 20px;
                          }

                          p {
                            font-family: Arial, Helvetica, sans-serif;
                          }

                          img {
                                display: block;
                                margin-left: auto;
                                margin-right: auto;
                                width: auto; 
                                height: 40px;
                                padding: 10px;
                              }
                        `;

        const d = new printd();

        d.print( document.getElementById('patient'), cssText );
      },

      dateOfBirth_save () {
        this.$refs.dateOfBirth_menu.save(this.dateOfBirth);
      },

      async send() {
        const validPatientID = await this.checkPatientID();

        if(validPatientID) {
          try {         

            var genderID;

            switch(this.gender){
              case 'Unknown':
                genderID = 0;
                break;
              case 'Male':
                genderID = 1;
                break;
              case 'Female':
                genderID = 2;
                break;
              case 'Other':
                genderID = 3;
                break;
              default:
                genderID = 0;
            }

            var encodedData = this.encodeContractSendFunction(
              abiJson, 
              'setPatientDetails', 
              [
                this.patientID, 
                this.fullName, 
                this.dateOfBirth.replace(/-/g,""),
                this.myOffspringID,
                genderID,
                this.email, 
                this.address, 
                this.phoneNumber
              ]
            );

            this.confirmSendDialog = true;

          } catch (e) {
            this.$root.error('Params error');
            this.$root.log.error('send_to_contract_encode_abi_error', e.stack || e.toString() || e);
            this.confirmSendDialog = false;
            return false;
          }

          try {
            this.rawTx = await webWallet.getWallet().generateSendToContractTx(
              contractAddress, 
              encodedData, 
              this.gasLimit, 
              this.gasPrice, 
              this.fee
            );
          } catch (e) {
            this.$root.log.error('send_to_generate_tx_error', e.stack || e.toString() || e);
            alert(e.message || e);
            this.confirmSendDialog = false;
            return false;
          }

          this.canSend = true;
        }
      },

      async confirmSend() {
        this.sending = true;
        try {
          const txId = await webWallet.getWallet().sendRawTx(this.rawTx);
          this.confirmSendDialog = false;
          this.sending = false;
          const txViewUrl = server.currentNode().getTxExplorerUrl(txId);
          this.$root.success(`Successful sent! You can follow the transaction on <a href="${txViewUrl}" target="_blank">${txViewUrl}</a>`, true, 0);
          this.$emit('send');

          this.patientForm = false;
          this.awaitingTx = true;

          this.drawQrCode();

          const interval = setInterval(() => {

            axios.get('https://explorer.htmlcoin.com/api/tx/' + txId)
            .then(result=>{
              console.log('Checking Tx...')

              if(result.data.confirmations > 0) {
                clearInterval(interval);
                this.awaitingTx = false;

                if(result.data.receipt[0].excepted != 'None') {
                  this.txError = true;
                  this.txErrorDesc = 'The transaction has returned an error. Please review the info provided, and if the error persists, please contact the system administrator.';
                } else {
                  this.txConfirmed = true;
                }
              }

            })
            .catch(console.error)
          }, 30*1000)

        } catch (e) {
          alert(e.message || e);
          this.$root.log.error('send_to_contract_post_raw_tx_error', e.response || e.stack || e.toString() || e);
          this.confirmSendDialog = false;
        }
      },

      async checkPatientID(){
        try{
          if(this.patientID == '') {
            this.patientID = sha256(this.fullName+Date.now());
            return true;
          } else {
            var decodedResult = await this.callContractFunction(
              contractAddress, 
              abiJson, 
              'isPatientValid', 
              [this.patientID]
            );                     
            
            if(decodedResult[0].toString() == 'true'){
              alert('Patient ID already taken. Please either try another one, or let the field blank so the system will generate a new ID.');
              this.patientID = '';
              return false;
            } else {
              return true;
            }
          }

        } catch (e) {
            this.$root.log.error('call_contract_call_contract_error', e.stack || e.toString() || e);
            alert(e.message || e);
            this.execResultDialog = false;
        } 
      },

      findIndexByName(abiJson, name){
        return abiJson.findIndex(function(item){
          return item.name === name
        });
      },

      async callContractFunction(contractAddress, abiJson, functionName, params){
        const encodedData = abi.encodeMethod(
          abiJson[
            this.findIndexByName(
              abiJson,
              functionName
            )
          ], 
          params
        ).substr(2);
        var encodedResult = await webWallet.getWallet().callContract(contractAddress, encodedData);          
        encodedResult = '0x' + encodedResult;

        return abi.decodeMethod(abiJson[this.findIndexByName(abiJson,functionName)], encodedResult);
      },

      encodeContractSendFunction(abiJson, functionName, params){
        return abi.encodeMethod(
          abiJson[this.findIndexByName(abiJson, functionName)], 
          params
        ).substr(2);
      },

      onCopySucc: function() {
        this.$root.success('copy success');
      },
      onCopyError: function() {
        this.$root.error('copy fail');
      },

      drawQrCode() {
        qrcode.toDataURL(`${this.patientID}`, (err, url) => {
          this.qr = url;
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/controllers/Patient-Create.vue